import axios from "axios";
import { persistSessionToken } from "../utils/sessionAuth";

//export const API_INTERNAL_URL = "http://143.198.5.94:8080";
const { REACT_APP_MY_ENV } = process.env;

const axiosInstance = axios.create({
  baseURL: REACT_APP_MY_ENV,
});

function getSessionAuthorizationHeader() {
  const tokenPayload = JSON.parse(
    sessionStorage.hasOwnProperty("token_store")
      ? sessionStorage.getItem("token_store")
      : JSON.stringify({ token: "empty" })
  );

  return "Bearer " + tokenPayload.token;
}

export function signIn(credentials) {
  return new Promise((resolve, reject) => {
    axiosInstance({
      method: "post",
      url: "/login",
      data: {
        email: credentials.email,
        password: credentials.password,
      },
    })
      .then((response) => {
        if (response.status === 200) {
          persistSessionToken(response.data, Boolean(credentials.remember));
          resolve(response.data);
        }
        reject(response.data);
      })
      .catch((error) => {
        //console.log("ERROR");
        reject(error);
      });
  });
}

export function authenticateWithGoogle(credential) {
  return new Promise((resolve, reject) => {
    axiosInstance({
      method: "post",
      url: "/social/google/authenticate",
      data: {
        credential,
      },
    })
      .then((response) => {
        if (response.status === 200) {
          if (response.data?.token) {
            persistSessionToken(response.data.token);
          }

          resolve(response.data);
        }

        reject(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function completeGoogleRegistration(credentials) {
  return new Promise((resolve, reject) => {
    axiosInstance({
      method: "post",
      url: "/social/google/complete-registration",
      data: {
        credential: credentials.credential,
        firstName: credentials.firstName,
        lastName: credentials.lastName,
        company: credentials.company,
        businessType: credentials.businessType,
        phoneNumber: credentials.phone,
        mobileNumber: credentials.mobileNumber,
        identificationType: credentials.identificationType,
        identificationNumber: credentials.identificationNumber,
        streetAddress: credentials.streetAddress,
        city: credentials.city,
        country: credentials.country,
        eulaAgreed: credentials.eulaAgreed,
        referral: credentials.referral,
      },
    })
      .then((response) => {
        if (response.status === 200) {
          if (response.data?.token) {
            persistSessionToken(response.data.token);
          }

          resolve(response.data);
        }

        reject(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function linkGoogleAccount(credential) {
  return new Promise((resolve, reject) => {
    axiosInstance({
      method: "post",
      url: "/social/google/link",
      headers: {
        Authorization: getSessionAuthorizationHeader(),
      },
      data: {
        credential,
      },
    })
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data);
        }

        reject(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function fetchGoogleLinkStatus() {
  return new Promise((resolve, reject) => {
    axiosInstance({
      method: "get",
      url: "/social/google/link-status",
      headers: {
        Authorization: getSessionAuthorizationHeader(),
      },
    })
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data);
        }

        reject(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function signUp(credentials) {
  return new Promise((resolve, reject) => {
    axiosInstance({
      method: "post",
      url: "/signUp",
      data: {
        firstName: credentials.firstName,
        lastName: credentials.lastName,
        company: credentials.company,
        email: credentials.email,
        password: credentials.password,
        confirmPassword: credentials.confirmPassword,
        businessType: credentials.businessType,
        phoneNumber: credentials.phone,
        mobileNumber: credentials.mobileNumber,
        identificationType: credentials.identificationType,
        identificationNumber: credentials.identificationNumber,
        streetAddress: credentials.streetAddress,
        city: credentials.city,
        country: credentials.country,
        eulaAgreed: credentials.eulaAgreed,
        referral: credentials.referral,
      },
    })
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data);
        }
        reject(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function getReferralInvitationPartner(code) {
  return axiosInstance({
    method: "get",
    url: "/public/referrals/" + encodeURIComponent(code),
  }).then((response) => response.data);
}

export function resetPassword(credentials) {
  return new Promise((resolve, reject) => {
    axiosInstance({
      method: "post",
      url: "/reset-password",
      data: {
        email: credentials.email,
      },
    })
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data);
        }
        reject(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function authChangePassword(credentials) {
  return new Promise((resolve, reject) => {
    axiosInstance({
      method: "post",
      url: "/change-password",
      data: {
        token: credentials.token,
        password: credentials.password,
        confirmPassword: credentials.confirmPassword,
      },
    })
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data);
        }
        reject(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
